import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IEquipment } from '@core/interfaces';
import { EQP_LOCATIONS } from '@core/constants';

@Component({
  selector: 'app-pneylu-equipment-select-modal',
  templateUrl: './pneylu-equipment-select-modal.component.html',
})
export class PneyluEquipmentSelectModalComponent implements OnInit {
  @Input() public equipmentList: IEquipment[];

  public items: IEquipment[] = [];
  public locationOptions = EQP_LOCATIONS;

  constructor(
    public modal: NgbActiveModal,
  ) { }

  public ngOnInit(): void {
    this.items = this.equipmentList.map((item: IEquipment) => item);
  }
}
